export default {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
    contained: {
      boxShadow: 'none',
      // Use callback to access theme
      '&.MuiButton-root': ({ theme }) => ({
        backgroundColor: 'hsl(0 0% 98%)',
        color: 'hsl(240 10% 3.9%)',
        fontWeight: 500,
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
        border: '1px solid hsl(240 5.9% 90%)',
        height: '40px',
        padding: '0 16px',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '20px',
        '&:hover': {
          backgroundColor: 'hsl(0 0% 96.1%)',
          borderColor: 'hsl(240 5.9% 88%)',
          boxShadow: 'none'
        },
        '&:focus-visible': {
          outline: '2px solid hsl(240 5.9% 90%)',
          outlineOffset: '2px'
        },
        '&:active': {
          backgroundColor: 'hsl(0 0% 93.0%)',
          borderColor: 'hsl(240 5.9% 86%)'
        },
        '&.Mui-disabled': {
          backgroundColor: 'hsl(0 0% 98%)',
          color: 'hsl(240 5% 64.9%)',
          cursor: 'not-allowed',
          borderColor: 'hsl(240 5.9% 90%)',
          opacity: 0.5
        }
      }),
      // Primary variant using theme colors
      '&.MuiButton-containedPrimary': ({ theme }) => ({
        backgroundColor: theme.palette.primary.main, // #f79222
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.main}`,
        '&:hover': {
          backgroundColor: theme.palette.primary.light,
          borderColor: theme.palette.primary.light
        },
        '&:active': {
          backgroundColor: theme.palette.primary.light,
          borderColor: theme.palette.primary.light
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          opacity: 0.5
        }
      })
    }
  }
};